import styled from 'styled-components';

export const ErrorEbonModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 44px auto;
    max-width: 565px;
    text-align: center;

    h1 {
        margin-bottom: 16px;
    }

    h1::after {
        display: none;
    }

    .recapText {
        margin-bottom: 20px;
    }

    .wrapper {
        flex-direction: column;
        flex: 1;
        background-color: ${props => props.theme.white};
        width: 100%;
        align-self: flex-start;
        padding: 0 20px 20px;
        border: 1px solid ${props => props.theme.whiteGrey};

        h3 {
            margin: 20px 0;
        }

        .recapUnavailable {
            display: flex;
            justify-content: space-around;
            margin-bottom: 20px;
        }
    }

    & > button {
        margin-top: 32px;
        font-weight: 400;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/ErrorEbonModalStyle.js